module.exports = __webpack_public_path__ + "media/2.504a298c.wav";